import React from "react";
import useReveal from "../../hooks/useReveal";
import { BDK } from "../../config/bdk";

const AnniversarySection = () => {
  useReveal();
  return (
    <section
      id="experiencia"
      data-testid="section-experiencia"
      className="bdk-section relative overflow-hidden isolate"
      style={{ background: "#fff", color: "var(--ink)" }}
    >
      <div
        className="relative grid lg:grid-cols-[1.15fr_.85fr] gap-10 lg:gap-8 items-center"
        style={{
          width: "min(1440px, calc(100% - 40px))",
          margin: "0 auto",
        }}
      >
        <div
          className="relative flex justify-center bdk-reveal bdk-reveal--left"
          style={{ "--reveal-delay": "0ms" }}
        >
          <img
            src={BDK.logos.anniversary14}
            alt="14 años BDKSISTEMAS"
            data-testid="anniversary-logo"
            className="anniv-logo relative w-[460px] sm:w-[560px] md:w-[720px] lg:w-full h-auto"
            style={{ maxWidth: "900px" }}
          />
        </div>

        <div
          className="bdk-reveal bdk-reveal--right"
          style={{ "--reveal-delay": "80ms" }}
        >
          <p className="kicker">Respaldo real</p>
          <h2 className="font-display text-[42px] sm:text-[54px] md:text-[64px] lg:text-[72px]">
            Desarrollo web respaldado
            <br />
            por BDKSISTEMAS.
          </h2>
          <p className="mt-5 text-[#666873] text-[15px] md:text-[16px] max-w-[560px]">
            El diseño y desarrollo web es la nueva división de BDKSISTEMAS: la
            misma empresa que desde 2012 impulsa a gimnasios, spas, lavanderías,
            locales comerciales y restaurantes en México con informática y
            puntos de venta. No somos una agencia improvisada: somos un negocio
            establecido que ahora también construye tu página web.
          </p>

          <div className="mt-8 grid grid-cols-3 gap-3">
            {[
              { k: "2900+", v: "Clientes activos en sistemas BDK" },
              { k: "5000+", v: "Instalaciones realizadas" },
              { k: "4.6★", v: "50+ opiniones de clientes" },
            ].map((s, i) => (
              <div
                key={s.v}
                data-testid={`anniversary-stat-${i}`}
                className="p-4 md:p-5 rounded-[10px]"
                style={{
                  background: "var(--ink-2)",
                  border: "1px solid #34353e",
                  borderLeft: "4px solid var(--red)",
                }}
              >
                <div className="font-display text-[32px] md:text-[40px] leading-none text-white">
                  {s.k}
                </div>
                <div className="text-[10px] uppercase tracking-widest text-[#b8b9c1] mt-2">
                  {s.v}
                </div>
              </div>
            ))}
          </div>

          <a
            href="#contacto"
            data-testid="anniversary-cta"
            className="bdk-btn bdk-btn--primary bdk-btn--lg mt-8"
          >
            Solicitar mi propuesta
          </a>
        </div>
      </div>
    </section>
  );
};

export default AnniversarySection;
